import { useEffect, useState } from 'react'
import { request } from '../../../Redux/Sagas/requests/api'
import { FAQItem } from '../RaiseTicket/faqList'
import { Button } from 'reactstrap'
import { primary_color } from '../../../Helper/uiHelper'
import { set } from 'date-fns'
import Loader from 'react-loaders'

const FAQs = ({ searchValue, additionalSetting, loading, setLoading }) => {
  const [list, setList] = useState([])
  const [pageInfo, setPageInfo] = useState()

  const pageSize = additionalSetting?.pagination
  useEffect(() => {
    setLoading(true)
    request('raise-ticket/get-faq-question', 'POST', { pageSize, searchKey: searchValue, faq_type: additionalSetting?.faq_type }).then((res) => {
      if (res?.data?.data) {
        setList(res?.data?.data)
        setPageInfo(res?.data)
        setLoading(false)
      }
    })
  }, [searchValue])

  const loadMore = () => {
    request('raise-ticket/get-faq-question', 'POST', {
      pageSize,
      searchKey: searchValue,
      page: pageInfo?.current_page + 1,
      faq_type: additionalSetting?.faq_type,
    }).then((res) => {
      if (res?.data?.data) {
        setList((data) => {
          return [...data, ...res?.data?.data]
        })
        setPageInfo(res?.data)
      }
    })
  }

  if (loading)
    return (
      <div style={{ textAlign: 'center', marginTop: '3rem' }}>
        <Loader color='#3f6ad8' type='ball-pulse' />
      </div>
    )
  return (
    <div className='my-5'>
      {list?.length === 0 && (
        <div className='d-flex align-items-center justify-content-center mt-5'>
          <img src='not_found.png' style={{ width: '20rem' }}></img>
        </div>
      )}
      {list?.map((item) => {
        return <FAQItem question={item?.question} answer={item?.answer} />
      })}

      {pageInfo?.current_page < pageInfo?.last_page && (
        <div className='mt-4 d-flex justify-content-center'>
          <div
            className='subtitle1 px-4 py-1 cursor-pointer'
            onClick={() => {
              loadMore()
            }}
            style={{ border: `1px solid ${primary_color}`, color: primary_color, borderRadius: '0.3rem' }}>
            Show More
          </div>
        </div>
      )}
    </div>
  )
}

export default FAQs
